export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 60,
  numberOfInstallments: 3,
}
